import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import AddAndEditWorkFlow from './AddAndEditWorkFlow';
import WorkflowList from '../../WorkflowList'

const WorkFlow = ({
  location,
}) => {
  const pairs = queryString.parse(location.search);

  return (
    <React.Fragment>
      {!_.isEmpty(pairs) && pairs.id ?
        <AddAndEditWorkFlow
          workFlowId={pairs.id}
        /> :
        <WorkflowList />
      }
    </React.Fragment>
  );
};

export default withRouter(WorkFlow);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/container/index.jsx